module.exports = __webpack_public_path__ + "img/arrowsContact.6faa9791.svg";